// 此处用于存放所有登录相关的接口请求
import request from '@/utils/request'

export const createOrder = (orderData) => {
  return request.post('/api/create_order', orderData)
}
export const checkOrderStatus = (orderId) => {
  return request.get(`/api/check_order_status/${orderId}`)
}
